import type { CartArticleType } from '../../types';
import { PRODUCT_STATUS } from '../../constants';

interface ArticlesPresentationState {
  sortedArticles: CartArticleType[];
  inactiveArticles: CartArticleType[];
  inactiveChildIds: number[];
  hasInactiveArticles: boolean;
}

function filterInactiveArticles(articles: CartArticleType[]): CartArticleType[] {
  return articles.filter(item => item.product.status === PRODUCT_STATUS.INACTIVE);
}

function filterActiveArticles(articles: CartArticleType[]): CartArticleType[] {
  return articles.filter(item => item.product.status !== PRODUCT_STATUS.INACTIVE);
}

function filterInactiveChildArticles(articles: CartArticleType[]): number[] {
  return articles.flatMap(item =>
    (item.childArticles ?? [])
      .filter(child => child.product.status === PRODUCT_STATUS.INACTIVE)
      .map(child => child.id),
  );
}

export function getArticlesPresentationState(
  articles: CartArticleType[] | null | undefined,
): ArticlesPresentationState {
  if (!articles?.length) {
    return { sortedArticles: [], hasInactiveArticles: false, inactiveArticles: [], inactiveChildIds: [] };
  }

  const activeArticles = filterActiveArticles(articles);
  const inactiveArticles = filterInactiveArticles(articles);
  const inactiveChildIds = filterInactiveChildArticles(articles);
  const hasInactiveArticles = inactiveArticles.length > 0 || inactiveChildIds.length > 0;

  return {
    sortedArticles: [...activeArticles, ...inactiveArticles],
    hasInactiveArticles,
    inactiveArticles,
    inactiveChildIds,
  };
}
